@if (isVisible()) {
  @if (isVimeoMedia() || isUnspecifiedVimeoVideoMedia()) {
    <div>
      <iframe
        [width]="sW$ | async"
        [height]="sH$ | async"
        [src]="media.url | vimeoUrl"
        [title]="media.title"
        allowfullscreen
        style="border: none"
        mozallowfullscreen
        webkitallowfullscreen></iframe>
    </div>
  }
  @if (isYouTubeMedia() || isUnspecifiedYoutubeVideoMedia()) {
    <youtube-player
      [title]="media.title"
      [videoId]="media.url | youTubeUrl"
      [width]="sW$ | async"
      [height]="sH$ | async"
      [placeholderImageQuality]="mediaQuality"></youtube-player>
  }
  @if (isImageMedia()) {
    <cx-media [alt]="media.altText" [container]="media" [title]="media.title"></cx-media>
  }
}
